<template>
  <div>
    <v-card elevation="6">
      <div class="pa-3">
        <div class="grid_select">
          <div class="grid_header_sell">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_cost" :src="img_cost"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 26px"><b>ต้นทุน - กำไร</b> <span class="text-danger" style="font-size:16px;">(การคำนวนไม่รวมคำสั่งซื้อของพาร์ทเนอร์)</span></div> 
          </div>
          <div class="ma-2">
            <v-select color="#86bc3a" :items="year_arr" @input="get_data(selected_year_cost)" item-text="show_year" item-value="year_eng" v-model="selected_year_cost" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
          </div>
        </div>
        <div class="mt-2">
          <v-simple-table class="v-data-table__wrapper" :items-per-page="perPage" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:default>
              <thead>
              <tr>
                <th></th>
                <th class="text-center" v-for="data in header" :key="data.text">{{ data.text }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td style="border-right: #d0d0d0 solid 1px">
                  <div><b>ต้นทุน</b></div>
                </td>
                <td class="text-center" v-for="data in cost" :key="data.id">
                  <div v-if="parseFloat(data.cost) == 0">-</div>
                  <div v-else>{{ format_number(data.cost) }}</div>
                </td>
              </tr>
              <tr>
                <td style="border-right: #d0d0d0 solid 1px">
                  <div><b>ยอดขาย</b></div>
                </td>
                <td class="text-center" v-for="data in sell_total" :key="data.id">
                  <div v-if="parseFloat(data.sales) == 0">-</div>
                  <div v-else><u>{{ format_number(data.sales) }}</u></div>
                </td>
              </tr>
              <tr>
                <td style="border-right: #d0d0d0 solid 1px; border-bottom: none !important">
                  <div><b>กำไร</b></div>
                </td>
                <td class="text-center" v-for="data in profit" :key="data.id">
                  <div v-if="parseFloat(data.profit) == 0">-</div>
                  <div v-else-if="parseFloat(data.profit) > 0 " style="color: #86bc3a;">{{ format_number(data.profit) }}</div>
                  <div v-else-if="parseFloat(data.profit) < 0" style="color: red;">{{ format_number(data.profit) }}</div>
                </td>
              </tr>
              <v-divider/>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import img_cost from "@/assets/profit.png";
import {formatNumber} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  name: "Sell_cost",
  data() {
    return {
      img_cost: img_cost,
      perPage: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      year_arr: [],
      selected_year_cost: null,
      header: [
        // {
        //   text: '',
        //   value: '',
        //   sortable: false,
        //   fixed: true,
        //   width: '150px',
        // },
        {
          text: 'มกราคม',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'กุมภาพันธ์',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'มีนาคม',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'เมษายน',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'พฤษภาคม',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'มิถุนายน',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'กรกฎาคม',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'สิงหาคม',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'กันยายน',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'ตุลาคม',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'พฤศจิกายน',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'ธันวาคม',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
      cost: [
        {id: 1, name: '10000'},
        {id: 2, name: '10000'},
        {id: 3, name: '10000'},
        {id: 4, name: '10000'},
        {id: 5, name: '10000'},
        {id: 6, name: '10000'},
        {id: 7, name: '10000'},
        {id: 8, name: '10000'},
        {id: 9, name: '10000'},
        {id: 10, name: '10000'},
        {id: 11, name: '10000'},
        {id: 12, name: '10000'},
      ],
      sell_total: [
        {id: 1, name: '12000'},
        {id: 2, name: '15000'},
        {id: 3, name: '15000'},
        {id: 4, name: '16000'},
        {id: 5, name: '9000'},
        {id: 6, name: '10000'},
        {id: 7, name: '19000'},
        {id: 8, name: '18000'},
        {id: 9, name: '9500'},
        {id: 10, name: '13000'},
        {id: 11, name: '18000'},
        {id: 12, name: '20000'},
      ],
      profit: [
        {id: 1, status: 1, name: '2000'},
        {id: 2, status: 1,name: '5000'},
        {id: 3, status: 1,name: '5000'},
        {id: 4, status: 1,name: '6000'},
        {id: 5, status: 2,name: '1000'},
        {id: 6, status: 0,name: ''},
        {id: 7, status: 1,name: '9000'},
        {id: 8, status: 1,name: '8000'},
        {id: 9, status: 2,name: '500'},
        {id: 10, status: 1,name: '3000'},
        {id: 11, status: 1,name: '8000'},
        {id: 12, status: 1,name: '10000'},
      ],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    async year_function() {
      this.year_arr = []
      let arr_year = 10
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      for (let i = 0; i <= arr_year; i++) {
        let count_th = ((full_year + 543) + i);
        let count_eng = ((full_year) + i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_year_cost = this.year_arr[0].year_eng
      await this.get_data(this.selected_year_cost)
    },
    async get_data(year) {
      this.cost = []
      this.profit = []
      this.sell_total = []
      HTTP.get('/wholesales/sellsaletotalreportcostprofit?year=' + year)
          .then((res) => {
            if (res.data.success === true) {
              res.data.cost.forEach((data, index) => {
                this.cost.push({
                  id: index,
                  cost: data,
                })
              })
              res.data.profit.forEach((data, index) => {
                this.profit.push({
                  id: index,
                  profit: data,
                })
              })
              res.data.sales.forEach((data, index) => {
                this.sell_total.push({
                  id: index,
                  sales: data,
                })
              })
              console.log(res.data)
            }
          })
    }
  },
  mounted() {
    this.year_function()
  },
}
</script>

<style scoped>
.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}
.grid_header_sell {
  display: grid;
  grid-template-columns: 10% 90%;
}
@media only screen and (max-width: 1180px) {
  .v-data-table__wrapper >>> table {
    width: 1000px !important;
    border-spacing: 0;
  }
  .grid_select {
    display: grid;
    grid-template-columns: 70% 30%;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 22% 78%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 25% 75%;
  }
}
</style>
